import { useDispatch } from "react-redux";
import { Link } from "react-router-dom";
import { setGenre, setGenreID } from "../../redux/slices/genre";
import {
  NextArrow,
  PrevArrow,
} from "../../components/SlickButtons/SlickButtons";
import Slider from "react-slick";
import "./Genre.css";
import useDevice from "../../hooks/useDevice";
import CardSkeleton from "../../components/Skeleton/CardSkeleton";
import { useGetGenres } from "../../hooks/useGetGenres";

function Genre() {
  const dispatch = useDispatch();
  const { isMobile, isTablet } = useDevice();

  const { data: genres, isLoading } = useGetGenres();

  const sliderSettings = {
    dots: false,
    infinite: true,
    speed: 500,
    slidesToShow: isMobile ? 2 : isTablet ? 4 : 6,
    slidesToScroll: 1,
    nextArrow: <NextArrow />,
    prevArrow: <PrevArrow />,
  };

  return (
    <section className="Genre">
      <div className="section-title">
        <h3>Shop by Genre</h3>
      </div>
      <Slider {...sliderSettings}>
        {isLoading
          ? Array.from({ length: 8 }).map((_, index) => (
              <CardSkeleton key={index} width={"95%"} height={66} />
            ))
          : genres?.map(({ id, name, description, count }) => (
              <Link
                onClick={() => {
                  dispatch(setGenreID(id));
                  dispatch(setGenre(name.toLowerCase()));
                }}
                to={`discover`}
                className={`genre ${name}`}
                key={name}
              >
                <img src={description} alt={name} width={30} />
                <div className="genre-info">
                  <p>{name}</p>
                  <span>Count: {count}</span>
                </div>
              </Link>
            ))}
      </Slider>
    </section>
  );
}

export default Genre;
